<template>
  <v-container>
    <v-row justify="end">
      <v-btn 
        color="success" 
        @click="openPaymentDialog" 
        :disabled="purchaseInvoice.estatus>2">
        <v-icon small class="mr-2">fas fa-plus</v-icon> Registrar Pago
      </v-btn>
    </v-row>
    
    <v-row class="mb-2 justify-space-between shrink">
      <v-col cols="12" md="4">
        <h3 class="titulo text-h7">Información del Documento</h3>
        <table>
          <tbody>
            <tr>
              <td class="text-right">
                Documento:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black">{{purchaseInvoice.document_id}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                Fecha de Recepción:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black">{{purchaseInvoice.date_received|moment('DD/MM/YYYY')}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                {{ $store.getters.getInternational.tax_id_label }}:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black">{{purchaseInvoice.rutEmisor}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                Razón Social:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black">{{purchaseInvoice.rznSocEmisor}}</div>
              </td>
            </tr>
            <h3 class="titulo text-h7 mt-4">Montos y Pagos</h3>
            <tr>
              <td class="text-right">
                Neto:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black">{{purchaseInvoice.get_subtotal| moneda}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                {{ $store.getters.getInternational.purchase_tax_label }}:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black">{{purchaseInvoice.get_iva| moneda}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                Total:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black">{{purchaseInvoice.get_total| moneda}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                Pagado:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black">{{purchaseInvoice.get_payed| moneda}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                Saldo:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black">{{calculateRemainingBalance(purchaseInvoice.get_total, purchaseInvoice.get_payed, $store.getters.getInternational.code)| moneda}}</div>
              </td>
            </tr>
          </tbody>
        </table> 
      </v-col>
      
      <v-col cols="12" md="8">
        <v-data-table
          class=""
          :headers="headers"
          :items="purchaseInvoice.payments"
          :items-per-page="10"
          :loading="loading"
          :item-class="()=>{return 'row-style-normal'}"
          sort-by='date'
          :sort-desc="false"
          show-expand
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'fas fa-angle-double-left',
            lastIcon: 'fas fa-angle-double-right',
            prevIcon: 'fas fa-angle-left',
            nextIcon: 'fas fa-angle-right'
          }">
          <template #no-data>
            <v-alert :value="true" icon="fas fa-info-circle" class="ma-4">
              No existen pagos registrados
            </v-alert>
          </template>
          <template v-slot:item.tipo="{ item }">
            {{tipos[item.tipo-1]}}
          </template>
          <template v-slot:item.date="{ item }">
            {{item.date | moment('DD/MM/YYYY')}}
          </template>
          <template v-slot:item.amount="{ item }">
            {{item.amount| moneda}}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              class="error--text"
              x-small
              @click="()=>{
                paymentToRemove=item
                showConfirmDelete=true
              }"
            >fas fa-trash</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    
    <v-dialog v-model="toPayment" max-width="500">
      <v-card class="pa-6">
        <v-card-title class="titulo text-h5">Registrar Pago</v-card-title>
        <ValidationObserver ref="paymentForm" v-slot="{handleSubmit}">
          <v-form @submit.prevent="handleSubmit(addPayment)">
            <ValidationProvider name="Fecha" rules="required" v-slot="{ errors }">
              <v-text-field
                label="Fecha de Pago"
                v-model="newPayment.date"
                type="date"
                outlined
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider name="Tipo" rules="required" v-slot="{ errors }">
              <v-select
                class="text-end mr-2"
                v-model="newPayment.tipo"
                :items="tipos"
                :disabled="loading"
                label="Tipo de Pago"
                single-line
                outlined
                :error-messages="errors"
              />
            </ValidationProvider>
            <ValidationProvider name="Detalle" rules="required" v-slot="{ errors }">
              <v-text-field
                label="Detalle"
                v-model="newPayment.glosa"
                outlined
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider name="Monto" rules="required" v-slot="{ errors }">
              <v-text-field
                label="Monto"
                v-model="newPayment.amount"
                :type="getInternationalConfig().currency_decimals === 0 ? 'number' : 'text'"
                :min="0"
                :step="getInternationalConfig().currency_decimals === 0 ? '1' : '0.01'"
                outlined
                :error-messages="errors"
                @input="formatAmountInput"
              ></v-text-field>
            </ValidationProvider>
            <div class="text-center">
              <v-btn type="submit" color="success" :loading="loadingAddPayment" class="text-end">Guardar</v-btn>
            </div>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    
    <confirm
      v-model="showConfirmDelete" 
      message="¿Está seguro de eliminar el pago seleccionado?"
      @ok="removePayment"
      @cancel="showConfirmDelete=false"/>
  </v-container>
</template>

<script>
import {createPurchasePayment, deletePurchasePayment} from '@/api/purchases'
import notifications from '@/utils/notifications'
import { calculateRemainingBalance as calculateRemainingBalanceUtil, formatForInput, roundToRegionalDecimals } from '@/utils/decimalUtils'

export default {
  name: 'PurchaseInvoicePayDetail',
  props: ['purchaseInvoice'],
  data() {
    return {
      tipos: [
        'EFECTIVO',
        'CHEQUE',
        'TRANSFERENCIA',
        'DEPOSITO'
      ],
      headers: [
        {
          text: 'Tipo de Pago',
          align: 'start',
          value: 'tipo',
          class: 'table-header',
          show: true,
          align: 'start'
        },
        {
          text: 'Fecha',
          align: 'start',
          value: 'date',
          class: 'table-header',
          show: true,
          align: 'start'
        },
        {
          text: 'Detalle',
          align: 'start',
          value: 'glosa',
          class: 'table-header',
          show: true,
          align: 'start'
        },
        {
          text: 'Monto',
          align: 'start',
          value: 'amount',
          class: 'table-header',
          show: true,
          align: 'start'
        }, 
        {
          text: '',
          align: 'start',
          value: 'actions',
          class: 'table-header',
          show: true,
          align: 'center'
        },
      ],
      newPayment: {
        date: new Date().toISOString().substr(0,10),
        tipo: '',
        glosa: '',
        amount: 0
      },
      toPayment: false,
      loading: false,
      loadingAddPayment: false,
      paymentToRemove: '',
      showConfirmDelete: false,

    }
  },
  methods: {
    getInternationalConfig() {
      return this.$store.getters.getInternational
    },
    
    calculateRemainingBalance(total, paid, countryCode) {
      return calculateRemainingBalanceUtil(total, paid, countryCode)
    },
    
    formatAmountInput(value) {
      // Formatear el input según la configuración regional
      const config = this.getInternationalConfig()
      const countryCode = config.code
      
      // Si es Chile (sin decimales), redondear a entero
      if (config.currency_decimals === 0) {
        this.newPayment.amount = Math.round(parseFloat(value) || 0).toString()
      } else {
        // Para otros países, permitir decimales pero formatear correctamente
        const rounded = roundToRegionalDecimals(parseFloat(value) || 0, countryCode)
        this.newPayment.amount = rounded.toString()
      }
    },
    
    openPaymentDialog() {
      this.toPayment = true
      // Resetear formulario y calcular saldo pendiente
      this.resetPaymentForm()
      const remaining = this.calculateRemainingBalance(
        this.purchaseInvoice.get_total, 
        this.purchaseInvoice.get_payed, 
        this.$store.getters.getInternational.code
      )
      this.newPayment.amount = formatForInput(remaining, this.$store.getters.getInternational.code)
    },
    
    resetPaymentForm() {
      // Resetear el formulario de pago
      this.newPayment = {
        date: new Date().toISOString().substr(0,10),
        tipo: '',
        glosa: '',
        amount: 0
      }
      
      // Resetear las validaciones
      this.$nextTick(() => {
        if (this.$refs.paymentForm) {
          this.$refs.paymentForm.reset()
        }
      })
    },
    
    async addPayment() {
      this.loadingAddPayment = true
      
      // Redondear el monto según la configuración regional antes de enviar
      const config = this.getInternationalConfig()
      const roundedAmount = roundToRegionalDecimals(
        parseFloat(this.newPayment.amount) || 0, 
        config.code
      )
      
      await createPurchasePayment({
        date: this.newPayment.date,
        amount: roundedAmount,
        tipo: this.tipos.indexOf(this.newPayment.tipo) + 1,
        glosa: this.newPayment.glosa,
        purchase_invoice: this.purchaseInvoice.id,   
      })
      .then((data) => {
        this.toPayment = false
        this.loadingAddPayment = false
        this.purchaseInvoice.payments.push(data)
        this.resetPaymentForm()
        notifications.showSuccess('Pago registrado con éxito')
        this.$emit('refresh')
      })
      .catch((err) => {
        this.loadingAddPayment = false
        notifications.showError(err.response?.data?.message || 'Error al registrar pago')
      })
    },
    
    async removePayment() {
      this.loading = true
      await deletePurchasePayment(this.paymentToRemove.id)
      .then(() => {
        this.loading = false 
        this.paymentToRemove = ''
        this.showConfirmDelete = false
        notifications.showSuccess('Pago eliminado con éxito')
        this.$emit('refresh')
      })
      .catch((err) => {
        this.loading = false
        this.paymentToRemove = ''
        this.showConfirmDelete = false
        notifications.showError(err.response?.data?.message || 'Error al eliminar pago')
      })
    }
  }
}
</script>

<style>
</style> 